import DTUGlance from "./DTUGlance";
import EchoesDTUPreview from "./Echoes.jsx";
import KnowYourAlumni from "./KnowYourAlumni";
import MeetYourMentors from "./KnowYourMentors";
import LandingPage from "./LandingPage";
import ResearchDigest from "./ResearchDigest.jsx";

const Home = () => {
  return (
    <>
      <LandingPage id="home" />
      <DTUGlance id="" /> {/* Added ID */}
      <MeetYourMentors id="faculties" />
      <ResearchDigest id="digest" /> {/* Added ID */}
      <EchoesDTUPreview id="echo" /> {/* Added ID */}
      <KnowYourAlumni id="alumni" /> {/* Added ID */}
    </>
  );
};

export default Home;
